/**
 * Created by chenqifeng on 2016/8/31.
 */
import $                                                          from 'jquery';
import _                                                          from '_';
import maple                                                      from 'maple';
import * as api                                                   from './api/index';
import {getSec, setSec, getTimestamp, setTimestamp, cheatBreaker} from './util/sec';
import {setCookie}                                                from './util/cookie.js';
import isNeedLoginPath                                            from '../tg/util/isNeedLoginPath';

/**
 * @param opt   Object  Ajax 参数
 * @param page  Boolean 是否页面跳转
 * */
let requestStateList = {}
    ;

function load(optionsUser, optionsDefault){
	// 每次调用接口的时候设置一下 cookies，我也不知道有啥用
	let date = new Date()
        , year = date.getFullYear()
        , month = date.getMonth()
        , day = date.getDate()
        ;

	setCookie('tgVersion', 'web/' + year + month + day);

	let options = _.defaults(optionsUser, optionsDefault)
        ;

	// get 请求加随机数，解决 get 请求浏览器缓存问题
	if( options.type === 'get' || options.type === 'GET' ){
		options.cache = false;
	}

	if( options.contentType === 'application/json' && options.type === 'POST' ){
		options.data = JSON.stringify( options.data );
	}

	if( options.url ){
		switch( requestStateList[options.url] ){
			case undefined:{
				requestStateList[options.url] = false;
				return $.ajax( options );
			}
			case true:{
				requestStateList[options.url] = false;
				return $.ajax( options );
			}
			case false:{
				return;
			}
			default:{
				return;
			}
		}
	}
}

export let request = function(opt={}, page=false){
	// // 提示用户重新登录
	// function noticeRelogin(){
	//     if( maple.cookie('isLogin') == "true" && !localStorage.getItem('ssoConfirmed')){
	//         maple.alert({
	//             content: '您的账号已在其他终端登录，请重新登录',
	//             okFn(){
	//                 localStorage.setItem('ssoConfirmed', true);
	//                 maple.pageIns && maple.pageIns.changePage('/login/login.html', {loginBack: maple.url(location.href).replace({_rt: Date.now()}).pack()})
	//             }
	//         })
	//     }else{
	//         maple.pageIns && maple.pageIns.changePage('/login/login.html');
	//     }
	// }
	let _opt = {
            type: 'GET'
            , dataType: 'json'
            , async: true
            , timeout: 10000
            , xhrFields: {
                withCredentials: true
            }
        }
        , success = opt.success || function(){}
        , needSecKey = opt.needSecKey || false
        , secKeyOne = false
        , error = opt.tgError
        , tgError = opt.tgError
        , netError = opt.netError
        , isCheckLogin = opt.isCheckLogin
        ;

	opt.success = function(response){
		var secKey = response.secKey
            , timestamp = response.timestamp
            ;

		if( secKey && timestamp ){
			setSec( secKey );
			setTimestamp( timestamp );
		}

		if( opt.url ){
			requestStateList[opt.url] = true;
		}
		if( response.success ){
			// if(response.code===888||response.httpCode===888){
			//     noticeRelogin()
			// }else{
			success(response.data, response.timestamp, response.code, response);
			// }
		}
		else{
			// maple.notice().remove();
			if( response.code === 888
                && (isCheckLogin || typeof isCheckLogin === 'undefined') ){

				console.log(opt.url, '需要登录');

				// noticeRelogin()
				maple.pageIns && maple.pageIns.changePage('/login/login.html', {
					loginBack: encodeURIComponent( location.href )
				});
			}
			else if( response.code === 889 ){
				// 返回 889 证明该账户在别处登录
				// 2017-10-18 #26415
				if( isNeedLoginPath( location.pathname )
                    && !localStorage.getItem('ssoConfirmed') ){

					maple.alert({
						content: '您的账号已在其他终端登录，请重新登录'
                        , okFn(){
							localStorage.setItem('ssoConfirmed', true);
							maple.pageIns && maple.pageIns.changePage('/login/login.html', {
								loginBack: maple.url( location.href ).replace({
                                    _rt: Date.now()
								}).pack()
							});
						}
					});
				}
				else{
					tgError && tgError( response );
				}
			}
			else if( response.code === 100 ){
				/**
				 * 2021-11-03
				 * 现在 100 错误类型为 第一次联合登录需要快捷登录，目前不再弹窗提示
				 * */
				// // 2017-08-02 导购咨询功能全面升级，您当前的 APP 版本暂不支持此功能，请下载最新版天狗 APP 体验
				// maple.confirm({
				// 	content: response.message
				// 	, cancelText: '算了'
				// 	, cancelFn: ()=>{}
				// 	, okText: '去登录'
				// 	, okFn: ()=>{
				// 		maple.pageIns.changePage('/login/login.html', {
				// 			type: 1
				// 		});
				// 		// maple.pageIns.changePage('/index/loadAndroid.html');
				// 	}
				// });
				// tgError && tgError( response );
			}
			else{
				if( tgError ){
					tgError( response );
				}
				else{
					if( response && response.message && response.message !== 'undefined' ){
						maple.notice( response.message );
					}
					else{
						maple.notice('网络好像不给力喔，请检查一下您的网络设置');
					}
				}
			}
		}
	};
	opt.error = function(XMLHttpRequest, textStatus, errorThrown){
		if( netError && typeof netError === 'function' ){
			requestStateList[opt.url] = undefined;
			netError(XMLHttpRequest, textStatus, errorThrown);
		}
		else if( error && typeof error === 'function' ){
			error(XMLHttpRequest, textStatus, errorThrown);
		}
		else{
			if( textStatus === 'error' && XMLHttpRequest.status === 0 ){
				// ajax 在完成请求之前已经被取消，ajax 请求没有发出
			}
			else{
				maple.notice('网络好像不给力喔，请检查一下您的网络设置');
			}
		}
	};


	opt.data = opt.data || {};
	if( needSecKey ){
		// 前置接口返回了secKey
		if( getSec() != null && getSec() !== undefined ){
			if( getSec() === -1 && maple.cookie('isLogin') === 'true' && !secKeyOne ){
				secKeyOne = true;

				return api.member.secKey({
					success: function(data, timestamp, code, response){
						setSec( response.secKey );
						setTimestamp( response.timestamp );
						opt.data['secKey'] = getSec();
						opt.data['timestamp'] = getTimestamp();
						opt.data['secValue'] = cheatBreaker();

						return load(opt, _opt);
					}
				});
			}
			else{
				opt.data['secKey'] = getSec();
				opt.data['timestamp'] = getTimestamp();
				opt.data['secValue'] = cheatBreaker();

				return load(opt, _opt);
			}
		}
		else{
			return api.member.secKey({
				success: function(data, timestamp, code, response){
					setSec( response.secKey );
					setTimestamp( response.timestamp );
					opt.data['secKey'] = getSec();
					opt.data['timestamp'] = getTimestamp();
					opt.data['secValue'] = cheatBreaker();

					return load(opt, _opt);
				}
			});
		}
	}
	else{
		return load(opt, _opt);
	}
};